import { useEffect } from "react";
import ReactGA from 'react-ga';

const trackingId = process.env.REACT_APP_GA_TRACKING_ID ;

/**
 * 
 * Sends a GA (Google Analytics) event. (https://github.com/react-ga/react-ga). 
 * 
 */
const useGAEvent = (event: ReactGA.EventArgs) => {
    useEffect( () => {
        if(!trackingId){
            return
        }
        ReactGA.event(event) ;
    }, []) ;
}

export default useGAEvent ;
